import React, { useCallback, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import AbandonedCheckoutDetails from '../components/AbandonedCheckoutDetails';
import AdminSubpage from '../components/AdminSubpage';
import { abandonedCheckoutsAPI } from '../services/api';

const AbandonedCheckoutDetailPage = () => {
  const { checkoutId } = useParams();
  const navigate = useNavigate();
  const [checkout, setCheckout] = useState(null);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    if (!checkoutId) return;
    setLoading(true);
    try {
      const response = await abandonedCheckoutsAPI.getById(checkoutId);
      setCheckout(response.data.checkout ?? null);
      if (!response.data.checkout) {
        toast.error('Could not load abandoned cart.');
      }
    } catch (error) {
      toast.error(
        error.response?.data?.message || error.message || 'Error loading abandoned cart',
      );
      setCheckout(null);
    } finally {
      setLoading(false);
    }
  }, [checkoutId]);

  useEffect(() => {
    void load();
  }, [load]);

  const title = checkout?.buyer_label
    ? `Abandoned cart — ${checkout.buyer_label}`
    : 'Abandoned cart details';

  return (
    <AdminSubpage title={title} backTo="/abandoned-checkouts">
      {loading ? (
        <div className="loading">Loading cart…</div>
      ) : checkout ? (
        <AbandonedCheckoutDetails
          checkout={checkout}
          onDeleted={() => navigate('/abandoned-checkouts')}
        />
      ) : (
        <p>No cart loaded.</p>
      )}
    </AdminSubpage>
  );
};

export default AbandonedCheckoutDetailPage;
